import React from 'react'
import { View } from 'react-native'
import PropTypes from 'prop-types'

import { VFText } from '@vfgroup-oneplatform/foundation/Components'
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes'

import styles from './OfferDescription.Styles'

const OfferDescription = ({
  price,
  period,
  priceReduction,
}) => {
  const theme = useTheme()
  return (
    <View style={styles.container}>
      <VFText
        i18nKey={price ?? ''}
        style={styles.price}
      />
      <VFText
        i18nKey={period ? (period) : ''}
        style={styles.offerPeriod(theme)}
      />
      <VFText
        i18nKey={priceReduction ?? ''}
        style={styles.priceReduction}
      />
    </View>
  )
}

OfferDescription.defaultProps = {
  price: '',
  period: '',
  priceReduction: ''
}

OfferDescription.propTypes = {
  price: PropTypes.string,
  period: PropTypes.string,
  priceReduction: PropTypes.string,
}

export default OfferDescription
